import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { select } from 'd3-selection';

class DotPlot extends Component{
    componentDidMount(){
        this.renderDotPlot();
    }

    renderDotPlot = () => {
        const { data, keys: { x, y }, xScale, yScale } = this.props;

        // draw the dot plot
        select( this.dots )
            .selectAll( 'path' )
            .data( data )
            .enter()
            .append( 'circle' )
            .attr( 'r', 2 )
            .attr( 'cx', d => xScale()( d[x] ) )
            .attr( 'cy', d => yScale()( d[y] ) );
    }

    render(){
        const { styles } = this.props;
        return (
            <g className={styles.dots} ref={el => this.dots = el}>
            </g>
        );
    }
};

DotPlot.propTypes = {
    data: PropTypes.array.isRequired,
    keys: PropTypes.object.isRequired,
    styles: PropTypes.object,
    xScale: PropTypes.func.isRequired,
    yScale: PropTypes.func.isRequired,
};

export default DotPlot;
